import { createContext } from "react";

type FilterCtx = {
  isCategoriesOpen: boolean;
  setIsCategoriesOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isFeaturesOpen: boolean;
  setIsFeaturesOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isPlaceOpen: boolean;
  setIsPlaceOpen: React.Dispatch<React.SetStateAction<boolean>>;
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
  params: object;
  setParams: React.Dispatch<React.SetStateAction<object>>;
  traits: object;
  setTraits: React.Dispatch<React.SetStateAction<object>>;
  categories: object;
  setCategories: React.Dispatch<React.SetStateAction<object>>;
  place: object;
  setPlace: React.Dispatch<React.SetStateAction<object>>;
};

const defaultContext = {
  isCategoriesOpen: false,
  setIsCategoriesOpen: () => {},
  isFeaturesOpen: false,
  setIsFeaturesOpen: () => {},
  isPlaceOpen: false,
  setIsPlaceOpen: () => {},
  name: "",
  setName: () => {},
  params: {
    bust_max: 100,
    bust_min: 30,
    height_max: 217,
    height_min: 140,
    hips_max: 100,
    hips_min: 30,
    shoes_max: 50,
    shoes_min: 30,
    waist_max: 100,
    waist_min: 30,
  },
  setParams: () => {},
  traits: {
    /* "e-amber": false,
    "e-black": false,
    "e-blue": false,
    "e-brown": false,
    "e-green": false,
    "e-grey": false,
    "e-hazel": false,
    "h-black": false,
    "h-blonde": false,
    "h-brown": false,
    "h-colored": false,
    "h-red": false,
    "h-white-gray": false, */
  },
  setTraits: () => {},
  categories: {
    /* campaign_max: 100,
    campaign_min: 0,
    casting_max: 100,
    casting_min: 0,
    catalog_max: 100,
    catalog_min: 0,
    digital_max: 100,
    digital_min: 0,
    editorial_max: 100,
    editorial_min: 0,
    event_max: 100,
    event_min: 0,
    fashion_show_max: 100,
    fashion_show_min: 0,
    look_book_max: 100,
    look_book_min: 0,
    shooting_max: 100,
    shooting_min: 0,
    show_max: 100,
    show_min: 0,
    showroom_max: 100,
    showroom_min: 0,
    tv_commercial_max: 100,
    tv_commercial_min: 0, */
  },
  setCategories: () => {},
  place: {
    /*  europe: false, in_town: false, italy: false, worldwide: false */
  },
  setPlace: () => {},
};

const FilterContext = createContext<FilterCtx>(defaultContext);

export default FilterContext;
